module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.showDebug) ? _c('debug-tool') : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    },
    on: {
      "leave": _vm.leavePreloader
    }
  }, [(!_vm.showWebsite && !_vm.showDebug && !_vm.showEpisode && _vm.initialLoad) ? _c('loader') : _vm._e()], 1), _vm._v(" "), _c('router-view')], 1) : _c('div', [(_vm.isMobile) ? _c('mobile') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 712
// module chunks = 64